module.exports = require("core-js-pure/features/symbol/to-string-tag");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js/symbol/to-string-tag.js
// module id = 495
// module chunks = 13